import { render, staticRenderFns } from "./PasoDosPlantilla.vue?vue&type=template&id=1551c906"
import script from "./PasoDosPlantilla.vue?vue&type=script&lang=js"
export * from "./PasoDosPlantilla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports